<template>
  <Drawer width="400" :title="(openedUser ? '编辑' : '邀请') + '员工'" v-model="drawerOpened">
    <div class="drawer-content">
      <Form @submit.native.prevent ref="formItem" :model="formItem" :rules="ruleValidate" label-position="top">
        <FormItem label="名字" prop="name">
          <Input v-model="formItem.name" placeholder="输入名字..." />
        </FormItem>
        <FormItem label="手机号" prop="mobile">
          <Input v-model="formItem.mobile" placeholder="输入手机号..." />
        </FormItem>
        <FormItem label="企业微信号" prop="weworkUserId">
          <Input v-model="formItem.weworkUserId" placeholder="输入企业微信号..." />
        </FormItem>
        <!-- <FormItem label="密码" prop="password" v-if="!openedUser">
          <Input
            type="text"
            v-model="formItem.password"
            placeholder="输入密码"
          />
        </FormItem>-->
        <FormItem label="超级管理员" prop="superAdmin">
          <i-switch v-model="formItem.superAdmin" size="large">超级管理员</i-switch>
        </FormItem>
        <FormItem label="职位" prop="simpleRole" v-if="!formItem.superAdmin">
          <Select v-model="formItem.simpleRole" multiple placeholder="选择职位" @on-change='selectSimpleRole'>
            <Option :value="role.value" v-for="role in roleList" :key="role.value">{{ role.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="财务可见公司" prop="simpleRole" v-if="
          !formItem.superAdmin &&
          arrayIntersection(['acctManager', 'acct'], formItem.simpleRole)
            .length > 0
        ">
          <Select v-model="formItem.acctVisibleCompany" multiple filterable>
            <Option v-for="company in companyList" :value="company._id" :key="company._id">{{ company.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="销售项目成本可见公司" prop="simpleRole" v-if="
          !formItem.superAdmin &&
          arrayIntersection(['salesAssist'], formItem.simpleRole)
            .length > 0
        ">
          <Select v-model="formItem.salesCalcCostVisibleCompany" multiple filterable>
            <Option v-for="company in companyList" :value="company._id" :key="company._id">{{ company.name }}</Option>
          </Select>
        </FormItem>

        <FormItem label="采购可见工厂" prop="simpleRole" v-if="
          !formItem.superAdmin &&
          arrayIntersection(['purchase', 'purchaseLead'], formItem.simpleRole)
            .length > 0
        ">
          <Select v-model="formItem.purchaseVisibleFactory" multiple filterable>
            <Option v-for="factory in factoryList" :value="factory._id" :key="factory._id">{{ factory.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="销售订单可见工厂" prop="simpleRole" v-if="
          !formItem.superAdmin &&
          arrayIntersection(['productionWorkers', 'deliveryAssist', 'factoryLeader'], formItem.simpleRole)
            .length > 0
        ">
          <Select v-model="formItem.factoryRole" multiple filterable>
            <Option v-for="factory in factoryList" :value="factory._id" :key="factory._id">{{ factory.name }}</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="部门" prop="department">
                    <Tree :data="treeDepartmentData" ref="createDepartTree" @on-select-change="selectChange"></Tree>
        </FormItem>-->
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">创建</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { arrayIntersection } from "@/utils";

export default {
  name: "CreateUserDrawer",
  components: {},
  props: ["selectedDepart"],
  data() {
    return {
      drawerOpened: false,
      openedUser: null,
      treeDepartmentData: [],
      selectedDepartment: null,
      formItem: {
        name: null,
        mobile: null,
        superAdmin: false,
        simpleRole: [],
        acctVisibleCompany: [],
        salesCalcCostVisibleCompany: [],
        purchaseVisibleFactory: [],
        factoryRole: [],
        weworkUserId: null
      },
      ruleValidate: {
        name: [{ required: true, message: "名字为必填项", trigger: "blur" }],
        mobile: [{ required: true, message: "手机为必填项", trigger: "blur" }]
      },
      roleList: [
        {
          name: "无",
          value: "none"
        },
        {
          name: "总厂长",
          value: "allFactoryLeader"
        },
        {
          name: "厂长",
          value: "factoryLeader"
        },
        {
          name: "业务经理",
          value: "salesLead"
        },
        {
          name: "业务人员",
          value: "sales"
        },
        {
          name: "业务助理",
          value: "salesAssist"
        },
        {
          name: "技术服务经理",
          value: "technologyLead"
        },
        {
          name: "技术服务人员",
          value: "technology"
        },
        {
          name: "生产工人",
          value: "productionWorkers"
        },
        {
          name: "采购",
          value: "purchase"
        },
        {
          name: "司机",
          value: "driver"
        },
        {
          name: "跟单助理",
          value: "deliveryAssist"
        },
        {
          name: "运输部主管",
          value: "deliveryLeader"
        },
        {
          name: "人事",
          value: "hr"
        },
        {
          name: "财务",
          value: "acct"
        },
        {
          name: "财务总监",
          value: "acctManager"
        },
        {
          name: "采购经理",
          value: "purchaseLead"
        },
        {
          name: "业务费",
          value: "ywf"
        },
        {
          name: "查看修改母液",
          value: "semiRecipe"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      companyList: state => state.company.companyList,
      factoryList: state => state.factory.factoryList
    })
  },
  methods: {
    ...mapActions({
      createUser: "user/createUserAction",
      updateUser: "user/updateUserAction",
      getFactoryList: "factory/getFactorysAction"
    }),
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    openDrawer(data) {
      this.$refs.formItem.resetFields();
      this.formItem.simpleRole = [];
      this.formItem.acctVisibleCompany = [];
      this.formItem.salesCalcCostVisibleCompany = [];
      this.formItem.purchaseVisibleFactory = [];
      this.formItem.factoryRole = [];
      this.getFactoryList({});
      this.drawerOpened = true;
      this.openedUser = data;
      if (data) {
        this.formItem.name = data.name;
        this.formItem.mobile = data.mobile;
        this.formItem.mobile = data.mobile;
        this.formItem.superAdmin = data.superAdmin;
        this.formItem.weworkUserId = data.weworkUserId;
        this.formItem.simpleRole = data.simpleRole;
        if (
          this.arrayIntersection(
            ["acctManager", "acct"],
            this.formItem.simpleRole
          ).length > 0 && data.acctVisibleCompany.length > 0
        ) {
          this.formItem.acctVisibleCompany = data.acctVisibleCompany
            ?.map(item => {
              return item._id;
            })
            .join(",")
            .split(",");
        } else if (
          this.arrayIntersection(
            ["salesAssist"],
            this.formItem.simpleRole
          ).length > 0 && data.salesCalcCostVisibleCompany.length > 0
        ) {
          this.formItem.salesCalcCostVisibleCompany = data.salesCalcCostVisibleCompany
            ?.map(item => {
              return item._id;
            })
            .join(",")
            .split(",");
        } else if (
          this.arrayIntersection(
            ["purchase", "purchaseLead"],
            this.formItem.simpleRole
          ).length > 0 && data.purchaseVisibleFactory.length > 0
        ) {
          this.formItem.purchaseVisibleFactory = data.purchaseVisibleFactory
            ?.map(item => {
              return item._id;
            })
            .join(",")
            .split(",");
        } else if (
          this.arrayIntersection(
            ["productionWorkers", "deliveryAssist", "factoryLeader"],
            this.formItem.simpleRole
          ).length > 0
        ) {
          this.formItem.factoryRole = data.factoryRole
            ?.map(item => {
              return item._id;
            })
            .join(",")
            .split(",");
        }
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          try {
            if (this.openedUser) {
              if (this.formItem.purchaseVisibleFactory && this.formItem.purchaseVisibleFactory.length < 1) {
                this.formItem.purchaseVisibleFactory = [];
              }
              if (this.formItem.factoryRole && this.formItem.factoryRole.length < 1) {
                this.formItem.factoryRole = [];
              }
              if (this.formItem.acctVisibleCompany && this.formItem.acctVisibleCompany.length < 1) {
                this.formItem.acctVisibleCompany = [];
              }
              if (this.formItem.salesCalcCostVisibleCompany && this.formItem.salesCalcCostVisibleCompany.length < 1) {
                this.formItem.salesCalcCostVisibleCompany = [];
              }
              await this.updateUser({
                id: this.openedUser._id,
                data: this.formItem
              });
            } else {
              if (this.selectedDepart && this.selectedDepart._id) {
                this.formItem.department = this.selectedDepart._id;
              }
              if (this.formItem.superAdmin) {
                this.formItem.simpleRole = ["none"];
              }
              if (this.formItem.weworkUserId === null) {
                delete this.formItem.weworkUserId
              }
              const user = await this.createUser(this.formItem);
              this.$Modal.info({
                title: `用户：${user.name}`,
                content: `<p>手机号：${user.mobile}</p> <p>初始密码：${user.initialPassword}</p>`
              });
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    selectChange(r) {
      this.selectedDepartment = this.$refs.createDepartTree.getSelectedNodes()[0];
    },
    selectSimpleRole(item) {
      if (item.indexOf("factoryLeader") === -1) {
        delete this.formItem.factoryRole
      }
      console.log();
    }
  }
};
</script>

<style scoped lang="stylus"></style>
